/* global */

// Third-party imports
import $ from 'jquery';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'general_donation_cta';
export let global_vars = {};

// Local imports
import { postProductToCart } from '../util/postDonationProduct.js';
import { push_data_object } from '../datalayer/gtm/gtm_push.js';

function pushAddToCartDataLayerEvent(global) {
    let data_object = {
        event: 'add_to_cart',
        ecommerce: {
            items: [],
        },
    };

    let general_amount_field = global.document.getElementById(
        'generalDonationAmountField'
    );

    let typeInput = global.document.querySelector('.generalDonationForm-type');
    let brand = 'Pledge';
    if (typeInput.value.toLowerCase() === 'sg') {
        brand = 'One Time Donation';
    } else if (typeInput.value.toLowerCase() === 'yr') {
        brand = 'Yearly';
    }
    let productTitle = global.document.getElementById('gen_product_title')
        .value;
    let variantID = global.document.getElementById('gen_variant_id').value;
    let productID = global.document.getElementById('gen_product_id').value;

    //== gtm-push: general donation added to cart ==//
    data_object.ecommerce.items.push({
        item_name: productTitle,
        item_id: productID,
        price: general_amount_field.value,
        item_brand: brand,
        item_category: 'Donations',
        item_variant: variantID,
        item_list_name: 'Donations',
        quantity: '1',
    });

    push_data_object(data_object);
}

function formValidates(global) {
    let form = global.document.getElementById('generalDonationCTAForm');
    let validate_success = $(form)
        .parsley()
        .validate();
    return validate_success;
}

// Called when either the donate button is clicked,
// or enter is pressed in the custom amount field, and validation passes
function onSuccessfulSubmit(global) {
    let form = global.document.getElementById('generalDonationCTAForm');
    let selectedType = global.document.getElementById('cta-product-type').value;
    let selectedAmount = global.document.getElementById(
        'generalDonationAmountField'
    ).value;

    postProductToCart(global, selectedType, selectedAmount, form);
    pushAddToCartDataLayerEvent(global);
}

function initialize_add_button_listener(global) {
    $('#add').click(event => {
        event.preventDefault();
        if (!formValidates(global)) {
            return;
        }

        onSuccessfulSubmit(global);
    });
}

// Handle frequency radio button changes
function initialize_frequency_radio_button_listeners() {
    $('#sg_radio, #mp_radio, #yr_radio').change(function() {
        // Get the dataset that holds metafield values of the product
        let dataset = $('#cta-product-data').data();

        // Store the selected product type
        let productType = this.value;
        // Get the hidden input field for the product type value used in the submission of the form
        let typeInput = $('#cta-product-type');

        // Get the descode yearly value stored in the dataset (i.e. from the meta fields of the product)
        let desCodeYearlyValue = dataset.descodeyearly;
        // Get the descode monthly value stored in the dataset (i.e. from the meta fields of the product)
        let desCodeMonthlyValue = dataset.descodemonthly;
        // Get the descode single value stored in the dataset (i.e. from the meta fields of the product)
        let desCodeSingleValue = dataset.descodesingle;

        let desCodeInput = $('#cta-product-descode');

        typeInput.val(productType);

        if (this.value.toLowerCase() === 'sg') {
            desCodeInput.val(desCodeSingleValue);
        } else if (this.value.toLowerCase() === 'yr') {
            desCodeInput.val(desCodeYearlyValue);
        } else {
            desCodeInput.val(desCodeMonthlyValue);
        }
    });
}

// Handle keypress in custom amount field
function initialize_donation_cta_custom_amount_keypress(global) {
    let customAmountField = global.document.getElementById(
        'generalDonationAmountField'
    );
    if (!customAmountField) {
        return;
    }

    customAmountField.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
            if (!formValidates(global)) {
                return;
            }

            event.preventDefault();
            onSuccessfulSubmit(global);
        } else {
            let form = global.document.getElementById('generalDonationCTAForm');
            $(form)
                .parsley()
                .reset();
        }
    });
}

export function hide_input_change_feedback() {
    let widgetViewInCart = $('#widgetViewInCart');
    if (widgetViewInCart.length > 0) {
        $('#add').addClass('button--removed');
        widgetViewInCart.removeClass('button--removed');
    }
}

function initialize_input_change_listener() {
    let textInput = global.document.querySelector(
        '.js-customAmountWidget-hook'
    );
    let buttonState = global.document
        .querySelector('#add')
        .getAttribute('data-product-in-cart');
    if (textInput) {
        textInput.addEventListener('keydown', () => {
            if (buttonState === 'true') {
                $('#widgetViewInCart').addClass('button--removed');
                $('#add').removeClass('button--removed');
            }
        });
    }
}

function initialize_donation_widget_input() {
    let variantString = global.document.getElementById('gen_variant_id').value;
    let variantID = Number.isNaN(variantString) ? 0 : parseInt(variantString);

    let textInput = global.document.querySelector(
        '.js-customAmountWidget-hook'
    );
    if (!textInput) {
        return;
    }

    let url = '/cart.js';

    // Using getJSON will ensure that the data arg passed to the handler is a js
    // object
    $.getJSON(url)
        .then(data => {
            for (let index = 0; index < data.items.length; index++) {
                if (data.items[index].variant_id) {
                    if (data.items[index].variant_id === variantID) {
                        $(textInput).val(
                            data.items[index].final_line_price / 100
                        );
                    }
                }
            }
        })
        .catch(data => {
            let err = {
                msg: `GET failed for url: ${url}`,
                data,
            };
            throw err;
        });
}

export function initialize(global) {
    initialize_add_button_listener(global);
    initialize_input_change_listener();
    initialize_frequency_radio_button_listeners();
    initialize_donation_widget_input();
    initialize_donation_cta_custom_amount_keypress(global);
}
